import { Component } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: 'currency-cell',
    templateUrl: 'g-currency.component.html'
})
export class AGCurrencyRendererComponent implements ICellRendererAngularComp {
    private params: any;
    public value: number;

    agInit(params: any): void {
        this.params = params;
        this.value = this.params.value;
    }

    public getSymbol(): string {
          return '$';
    }

    refresh(params: any): boolean {
        this.params = params;
        this.value = params.value;
        return true;
    }
}